<aside class="portal-sidebar" [class.portal-sidebar--collapsed]="collapsed()" aria-label="Primary navigation">
  <div class="portal-sidebar__label">{{ 'common.workspace' | translate }}</div>
  <nav class="portal-nav">
    @if (canViewDashboard()) {
    <a routerLink="/dashboard" routerLinkActive="portal-nav__link--active" class="portal-nav__link" [routerLinkActiveOptions]="{ exact: true }" [title]="'navigation.dashboard' | translate">
      <svg class="portal-nav__icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" /><rect x="4" y="14" width="6" height="6" rx="1" /><rect x="14" y="14" width="6" height="6" rx="1" /></svg>
      <span class="portal-nav__label">{{ 'navigation.dashboard' | translate }}</span>
    </a>
    }
    <ng-container *ngTemplateOutlet="menuBranch; context: { $implicit: menuModules(), depth: 0 }"></ng-container>
    <ng-template #menuBranch let-items let-depth="depth">
      @for (module of items; track module.id) {
        @let children = childrenFor(module.id);
        @if (children.length) {
          <button class="portal-nav__link portal-nav__parent" type="button"
            [class.portal-nav__parent--expanded]="isExpanded(module.id)" (click)="toggleParent(module.id)"
            [attr.aria-expanded]="isExpanded(module.id)" [attr.aria-controls]="'sidebar-submenu-' + module.id" [title]="menuLabel(module)">
            <i [class]="iconClass(module.icon)" aria-hidden="true"></i>
            <span class="portal-nav__label">{{ menuLabel(module) }}</span>
            <svg class="portal-nav__chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
          </button>
          @if (isExpanded(module.id)) {
            <div class="portal-nav__children" [id]="'sidebar-submenu-' + module.id">
              @if (canOpen(module)) {
                <a [routerLink]="module.route" routerLinkActive="portal-nav__link--active"
                  [routerLinkActiveOptions]="{ exact: true }" class="portal-nav__link portal-nav__link--child">
                  <span class="portal-nav__label">{{ menuLabel(module) }}</span>
                </a>
              }
              <ng-container *ngTemplateOutlet="menuBranch; context: { $implicit: children, depth: depth + 1 }"></ng-container>
            </div>
          }
        } @else if (canOpen(module)) {
          <a [routerLink]="module.route" routerLinkActive="portal-nav__link--active" class="portal-nav__link"
            [class.portal-nav__link--child]="depth > 0" [title]="menuLabel(module)">
            <i [class]="iconClass(module.icon)" aria-hidden="true"></i>
            <span class="portal-nav__label">{{ menuLabel(module) }}</span>
          </a>
        }
      }
    </ng-template>
  </nav>
</aside>
